export default __webpack_public_path__ + "static/relative-book-bold-ddbc3997783576f8e9bc950c84ec4378.woff2";